module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-footer-email-7f4518567f45fb14118ea8b8262d05f2.png";